import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import {ActivatedRoute, Params, Router} from "@angular/router";
import {takeUntil} from "rxjs/operators";
import {Subject} from "rxjs";
// import { ComponentAbstract } from 'src/app/features/abstracts/component.abstract';

@Component({
  selector: 'mbb-page-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.scss']
})
export class NotFoundComponent {
  // getTranlateService(): TranslateService {
  //   return this.translateService;
  // }
  public ngUnsubscribe = new Subject();
  public queryParams: Params;
  public title = '';
  public button = '';
  constructor(private translate: TranslateService, private router: Router, private route: ActivatedRoute) {
    this.title = this.translate.instant('error.title');
    this.button = this.translate.instant('error.button');
    this.route.queryParams.pipe(takeUntil(this.ngUnsubscribe)).subscribe((queryParams: Params) => {
      try {
        this.parseParams(queryParams);
      } catch (e) {
        console.log("error", e)
      }
    });
    this.goTo('/mobilebanking-referral', this.queryParams);
  }

  private parseParams(queryParams: Params) {
    this.queryParams = queryParams;
  }

  goTo(state: string, params?: any, replaceUrl?: boolean, relativeTo?: ActivatedRoute) {
    replaceUrl = replaceUrl == null ? false : replaceUrl;
    this.router.navigate([state], { queryParams: params, relativeTo, replaceUrl });
  }

  /**
   * Xử lý destroy data trên component
   */
  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
    this.destroyData();
  }

  protected destroyData(): void { }
}
